import React from 'react';

import { WrapperFlex, Image, NavbarPrimary } from '@unimed-fesp/components';

import { FiPrinter } from 'react-icons/fi';

import { legacyRoutes } from '../../routes/legacyRoutes';
import UnimedLogo from '../../assets/images/login/logo-unimed-fesp.svg';
import FespANS from '../../assets/images/FespANS.jpg';

import {
  Container,
  Title,
  Text,
  Copy,
  ButtonImprimir,
  ImageANS,
} from './styles';

export default function TermoResponsabilidade() {
  const hoje = new Date();

  function ImprimirTermo(e) {
    e.stopPropagation();
    const { target } = e;

    window.print(() => {
      target.style.display = 'none';
    });
  }

  return (
    <>
      <NavbarPrimary nomeSistema="movcad" urlHome={legacyRoutes.Home.url} />
      <Container>
        <Image src={UnimedLogo} name="Unimed Logo" />
        <WrapperFlex justifySpaceBetween alignStart marginTop={28}>
          <Title>Termo de Responsabilidade - Massa Inicial</Title>
          <ButtonImprimir
            tipo="primary"
            id="btn-imprimir"
            type="button"
            paddingTop={8}
            paddingRight={8}
            paddingBottom={8}
            paddingLeft={8}
            width={120}
            alignCenter
            justifySpaceAround
            font="16px unimed_slabregular"
            onClick={ImprimirTermo}
          >
            imprimir
            <FiPrinter />
          </ButtonImprimir>
        </WrapperFlex>

        <Text>
          A contratante, vem pelo presente termo, autorizar a troca de
          informações cadastrais para inclusão da massa inicial de
          beneficiários. A contratante assume total responsabilidade pelo uso
          adequado do login e senha da ferramenta de Movimentação Cadastral
          (MOVCAD), comprometendo-se a observar as regras e prazos contratuais,
          assim como atender as exigências da Agência Nacional de Saúde
          Suplementar (ANS).
        </Text>

        <ImageANS src={FespANS} alt="ANS" />
        <Copy>
          {hoje.getFullYear().toString()} © Unimed Fesp | Sistema MovCad
        </Copy>
      </Container>
    </>
  );
}
